// extracted by mini-css-extract-plugin
export default {"firstCellFlex":"Style_firstCellFlex__veMzu","row1":"Style_row1__edtTS"};